import axios from 'axios';

const state = {
    leaderDetails: {
        people: {
            firstName: "",
            lastName: ""
        },
        securityRole: {
            securityRoleName: ""
        }
    }
};

const getters = {
    leaderDetails: state => state.leaderDetails
};

const actions = {
    fetchLeaderDetails: ({ commit }, leaderId) => {
        return new Promise((resolve, reject) => {
            axios.get('/api/proxy/leader/' + leaderId)
                .then(response => {
                    if (response.data && response.data.leaderDetails) {
                        
                        console.log('Leader details', response.data.leaderDetails[0]);
                        commit('setLeaderDetails', response.data.leaderDetails[0]);
                    }
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};

const mutations = {
    setLeaderDetails: (state, leaderDetails) => {
        state.leaderDetails.people = leaderDetails.people,
            state.leaderDetails.securityRole = leaderDetails.securityRole[0]
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};